module.exports = __webpack_public_path__ + "img/arrow-down.e8ca26dc.svg";